import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

// Pages

const PublicAppStorePage = Loader(
  lazy(() => import('src/content/public/AppStorePages'))
);
const MarketingLayout = Loader(
  lazy(() => import('src/content/marketing/MarketingLayout'))
);
const MarketingHome = Loader(
  lazy(() => import('src/content/marketing/MarketingHome'))
);
const FeaturesPage = Loader(
  lazy(() => import('src/content/marketing/FeaturesPage'))
);
const FeatureDetailPage = Loader(
  lazy(() => import('src/content/marketing/FeatureDetailPage'))
);
const SolutionDetailPage = Loader(
  lazy(() => import('src/content/marketing/SolutionDetailPage'))
);
const IntegrationsPage = Loader(
  lazy(() => import('src/content/marketing/IntegrationsPage'))
);
const SecurityPage = Loader(
  lazy(() => import('src/content/marketing/SecurityPage'))
);

const marketingPage = (page) => <MarketingLayout>{page}</MarketingLayout>;

// Status

const Status404 = Loader(
  lazy(() => import('src/content/pages/Status/Status404'))
);
const Status500 = Loader(
  lazy(() => import('src/content/pages/Status/Status500'))
);
const StatusComingSoon = Loader(
  lazy(() => import('src/content/pages/Status/ComingSoon'))
);
const StatusMaintenance = Loader(
  lazy(() => import('src/content/pages/Status/Maintenance'))
);

const baseRoutes = [
  {
    path: '/',
    element: marketingPage(<MarketingHome />)
  },
  {
    path: 'overview',
    element: <Navigate to="/" replace />
  },
  {
    path: 'features',
    element: marketingPage(<FeaturesPage />)
  },
  {
    path: 'features/:featureSlug',
    element: marketingPage(<FeatureDetailPage />)
  },
  {
    path: 'solutions/:solutionSlug',
    element: marketingPage(<SolutionDetailPage />)
  },
  {
    path: 'integrations',
    element: marketingPage(<IntegrationsPage />)
  },
  {
    path: 'security',
    element: marketingPage(<SecurityPage />)
  },
  {
    path: 'mobile',
    element: <PublicAppStorePage />
  },
  {
    path: 'support',
    element: <PublicAppStorePage />
  },
  {
    path: 'privacy',
    element: <PublicAppStorePage />
  },
  {
    path: 'terms',
    element: <PublicAppStorePage />
  },
  {
    path: 'account-deletion',
    element: <PublicAppStorePage />
  },
  {
    path: 'status',
    children: [
      {
        path: '/',
        element: <Navigate to="404" replace />
      },
      {
        path: '',
        element: <Status404 />
      },
      {
        path: '500',
        element: <Status500 />
      },
      {
        path: 'maintenance',
        element: <StatusMaintenance />
      },
      {
        path: 'coming-soon',
        element: <StatusComingSoon />
      }
    ]
  },
  {
    path: '*',
    element: <Status404 />
  }
];

export default baseRoutes;
